var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import sensorBatchStore from "../../../stores/ioT-stores/sensor-batch-store";
import LowSpinner from "../../common/low-spinner";
var StockManagementLoader = observer(function () {
    var sensorBatches = sensorBatchStore.sensorBatches, loadAllSensorBatches = sensorBatchStore.loadAllSensorBatches;
    var _a = __read(useState(true), 2), sensorsLoading = _a[0], setSensorsLoading = _a[1];
    useEffect(function () {
        if (!sensorBatches.length) {
            loadAllSensorBatches();
        }
    });
    var loadData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var data, data_1, data_1_1, sb, e_1_1, e_2;
        var e_1, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 10, 11, 12]);
                    // Remove Sensor Batches those having null in hardwareVariant.
                    if (sensorBatches.length < 1) {
                        return [2 /*return*/];
                    }
                    data = sensorBatches.filter(function (sb) { return sb.hardwareVariant; });
                    if (!(data.length > 0)) return [3 /*break*/, 9];
                    console.log("Number of sensor batches to be load: ".concat(data.length));
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 6, 7, 8]);
                    data_1 = __values(data), data_1_1 = data_1.next();
                    _b.label = 2;
                case 2:
                    if (!!data_1_1.done) return [3 /*break*/, 5];
                    sb = data_1_1.value;
                    if (!(sb.hardwareVariant && !sb.sensors)) return [3 /*break*/, 4];
                    setSensorsLoading(true);
                    console.log("Load sensors for sensor batch: ".concat(sb.hardwareVariant));
                    return [4 /*yield*/, sensorBatchStore.loadSensors(sb.id, false)];
                case 3:
                    _b.sent();
                    _b.label = 4;
                case 4:
                    data_1_1 = data_1.next();
                    return [3 /*break*/, 2];
                case 5: return [3 /*break*/, 8];
                case 6:
                    e_1_1 = _b.sent();
                    e_1 = { error: e_1_1 };
                    return [3 /*break*/, 8];
                case 7:
                    try {
                        if (data_1_1 && !data_1_1.done && (_a = data_1.return)) _a.call(data_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                    return [7 /*endfinally*/];
                case 8:
                    console.log("Load sensors for sensor batches is done!");
                    _b.label = 9;
                case 9: return [3 /*break*/, 12];
                case 10:
                    e_2 = _b.sent();
                    console.error("Something wrong while loading the sensors!", e_2);
                    return [3 /*break*/, 12];
                case 11:
                    setSensorsLoading(false);
                    return [7 /*endfinally*/];
                case 12: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        loadData();
    }, [sensorBatches]);
    if (!sensorBatches.length) {
        return _jsx(LowSpinner, { id: "sensorBatch.loading" });
    }
    else if (sensorsLoading) {
        return _jsx(LowSpinner, { id: "sensor.loading" });
    }
    else {
        return _jsx(Outlet, {});
    }
});
export default StockManagementLoader;
